import { Navigate, useParams } from "react-router-dom";
import useEstablishmentId from "../../hooks/useEstablishmentId";
import { useJwt } from "../../hooks/useJwt";
import { JSX } from "react";

interface EstablishmentProtectedRouteProps {
    children: JSX.Element;
}

interface TokenPayload {
    crbc?: boolean;
    establishment_id?: string;
}

const EstablishmentProtectedRoute = ({ children }: EstablishmentProtectedRouteProps) => {
    const tokenEstablishmentId = useEstablishmentId();
    const { establishmentId } = useParams();
    const decodedJwt = useJwt() as TokenPayload;

    if (decodedJwt?.crbc) {
        return children;
    }

    const establishmentMismatch =
        tokenEstablishmentId && establishmentId && tokenEstablishmentId !== establishmentId;

    if (establishmentMismatch) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default EstablishmentProtectedRoute;